// slider Js Mian

{
  const MultipleSlider = () => {
    let MultipleSliders = document.querySelectorAll(".swiperCus");
    let prevArrow = document.querySelectorAll(".prev");
    let nextArrow = document.querySelectorAll(".next");
    MultipleSliders.forEach((slider, index) => {
      let sliderLength = slider.children[0].children.length;
      let result = sliderLength > 1 ? false : true;
      const swiper = new Swiper(slider, {
        direction: "horizontal",
        loop: result,
        navigation: {
          nextEl: nextArrow[index],
          prevEl: prevArrow[index],
        },
        breakpoints: {
          200: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          640: {
            slidesPerView: 3,
            spaceBetween: 15,
          },
          768: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
        speed: 800,
      });
    });
  };

  window.addEventListener("load", MultipleSlider);
}
// slider Js Mian

{
  document.addEventListener("DOMContentLoaded", function () {
    const GridBox = document.querySelectorAll(".collec_box");
    GridBox.forEach(function name(box, index) {
      console.log(box, index);
      box.setAttribute("data-index", `${index}`);
      box.style.order = `${index}`;
    });
  });
}

{
  const tabsNav = document.querySelectorAll(".fqs_head ul li");
  const tabsContent = document.querySelectorAll(".fqs-tbs-cntnt");

  tabsNav.forEach((items, ind) => {
    items.addEventListener("click", () => {
      tabsNav.forEach((remove) => {
        remove.classList.remove("active");
      });

      items.classList.add("active");

      tabsContent.forEach((content) => {
        content.classList.remove("active");
      });

      tabsContent[ind].classList.add("active");
    });
  });
}

{
  document
    .querySelectorAll(".menu_icon, .menu_icon_cross")
    .forEach(function (element) {
      element.addEventListener("click", function () {
        var menuOpen = document.querySelectorAll(".menu__layout");
        menuOpen.forEach(function (element) {
          element.classList.toggle("isActive");
        });
      });
    });
}

{
  // document.addEventListener("scroll", function () {
  //   let scrollPosition = window.scrollY;
  //   let targetElement = document.querySelector(".navBar_Main");
  //   if (scrollPosition > 100) {
  //     targetElement.classList.add("Sticky");
  //   } else {
  //     targetElement.classList.remove("Sticky");
  //   }
  // });
}

// Accordion Script

{
  document.addEventListener("DOMContentLoaded", function () {
    const accordionItems = document.querySelectorAll(".accordion-item");
    if (accordionItems.length > 0) {
      accordionItems[0].classList.add("open");
    }
    accordionItems.forEach((item) => {
      const header = item.querySelector(".accordion-item-header");
      header.addEventListener("click", () => {
        document.querySelectorAll(".accordion-item").forEach((otherItem) => {
          if (otherItem !== item && otherItem.classList.contains("open")) {
            otherItem.classList.remove("open");
          }
        });
        item.classList.toggle("open");
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const ratingContainers = document.querySelectorAll(".peo-rating");

    ratingContainers.forEach((container) => {
      const ratingValue = parseInt(container.getAttribute("data-rating"), 10);
      const stars = container.querySelectorAll("ul li");

      for (let i = 0; i < ratingValue; i++) {
        stars[i].classList.add("fill");
      }
    });
  });
}

// Varient Value

window.addEventListener("load", () => {
    const variantSelects = document.querySelectorAll("variant-selects fieldset");

    variantSelects.forEach((variant) => {
        const radioButtons = variant.querySelectorAll('input[type="radio"]');
        const span = document.createElement("span");

        // Append the span to the legend once
        variant.querySelector("legend").appendChild(span);

        radioButtons.forEach((radioButton) => {
            // Update the span's text to the currently selected radio button's value on load
            if (radioButton.checked) {
                span.innerText = ` : ${radioButton.value}`;
            }

            // Add change event listener to each radio button
            radioButton.addEventListener("change", () => {
                if (radioButton.checked) {
                    span.innerText = ` : ${radioButton.value}`;
                }
            });
        });
    });
});

